import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

// Request deduplication cache
const requestCache = new Map();

let helpers = {
  createMarket(market, eventMetadatum, options){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = `${process.env.REACT_APP_API}/markets?current_company=${localStorage.current_company_id}` +
      (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        market: market,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  updateMarket(market, eventMetadatum, options){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API}/markets/${market.id}?current_company=${localStorage.current_company_id}`
        + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : ''),
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        market: market,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteMarket(market_id, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${market_id}?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getMarkets(company_id, options){
    const url = `${process.env.REACT_APP_API}/markets/?current_company=${company_id ? company_id : localStorage.current_company_id}`
      + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getAllMarkets(company_id, options){
    const url = `${process.env.REACT_APP_API}/markets/all_markets?current_company=${company_id ? company_id : localStorage.current_company_id}`
      + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');

    // Check if identical request is already in progress
    const cacheKey = url;
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey);
    }

    const requestPromise = axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        requestCache.delete(cacheKey);
        return response.data;
      })
      .catch(error => {
        requestCache.delete(cacheKey);
        return serviceUtil.resultForError(error);
      });

    requestCache.set(cacheKey, requestPromise);
    return requestPromise;
  },
  getMarket(market_id, company_id, options) {
    let url;
    if (options) {
      url = `${process.env.REACT_APP_API}/markets/${market_id}/show_market?current_company=${company_id ? company_id : localStorage.current_company_id}`;
      if (options.recordDescriptor){
        url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
      }
    }
    else {
      url = `${process.env.REACT_APP_API}/markets/${market_id}?current_company=${company_id ? company_id : localStorage.current_company_id}`; 
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return response.data.market;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  addUserToMarket(userId, marketId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteUserFromMarket(userId, marketId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/remove_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  addVendorUserToMarket(userId, marketId, vendorCompanyId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_vendor_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
        vendor_company_id: vendorCompanyId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteVendorUserFromMarket(userId, marketId, vendorCompanyId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/remove_vendor_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
        vendor_company_id: vendorCompanyId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  addProjectTemplateToMarket(project_template, marketId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_project_template?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_template_id: project_template.id,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProjectTemplateFromMarket(project_template, marketId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/remove_project_template?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_template_id: project_template.id,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getVendorMarketUsers(vendorCompanyId){
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/users/by_vendor_with_markets?current_company=${localStorage.current_company_id}&vendor_company_id=${vendorCompanyId}`,
      timeout: 20000, 
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/marketsService.js